<template>
    <DsModal
        :is-open="isOpen"
        size="lg"
        show-close
        :title="$t('funnel.edit.config.item.screen')"
        class="config-open-screen-modal"
        @close="closeItemScreen"
    >
        <template #header>
            <DsFilledButton
                data-qa="save-button"
                @click="handleSave"
            >
                {{ $t('funnel.edit.save') }}
            </DsFilledButton>
        </template>
        <template #default>
            <DsRadioGroup v-model="defaultOptionValue" :options="options" />
        </template>
    </DsModal>
</template>

<script>
import {
    saveAutomationUserSettings,
} from './ItemScreenDisplayModal.api';

export const OPEN_OPTIONS = {
    automatically: 'automatically',
    manually: 'manually',
};
export default {
    name: 'ItemScreenDisplayModal',
    OPEN_OPTIONS,
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
        autoOpenConfigScreen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update-open-automatically-header', 'close-item-screen-modal'],
    data() {
        return {
            defaultOptionValue: this.autoOpenConfigScreen ? this.$options.OPEN_OPTIONS.automatically : this.$options.OPEN_OPTIONS.manually,
            options: [
                {
                    label: this.$t('funnel.edit.config.item.screen.option.open.automatically'),
                    value: this.$options.OPEN_OPTIONS.automatically,
                },
                {
                    label: this.$t('funnel.edit.config.item.screen.option.open.manually'),
                    value: this.$options.OPEN_OPTIONS.manually,
                },
            ],
        };
    },
    methods: {
        async handleSave() {
            try {
                await saveAutomationUserSettings(this.defaultOptionValue === this.$options.OPEN_OPTIONS.automatically);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error:', error.message);
            } finally {
                this.$emit('update-open-automatically-header', this.defaultOptionValue === this.$options.OPEN_OPTIONS.automatically);
                this.closeItemScreen();
            }
        },
        closeItemScreen() {
            this.$emit('close-item-screen-modal');
        },
    },
};
</script>

<style scoped lang="scss">
.config-open-screen-modal ::v-deep .modal-body {
    padding: 0;
}
</style>
